import { render, staticRenderFns } from "./Bloco5Videos.vue?vue&type=template&id=f537f024&scoped=true&"
import script from "./Bloco5Videos.vue?vue&type=script&lang=js&"
export * from "./Bloco5Videos.vue?vue&type=script&lang=js&"
import style0 from "./Bloco5Videos.vue?vue&type=style&index=0&id=f537f024&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f537f024",
  null
  
)

export default component.exports